import { forwardRef, memo, ReactNode } from 'react';
import { cn } from '../../lib/utils';

// ----------------------------------------------------------------------

interface ScrollbarProps extends React.HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

const Scrollbar = forwardRef<HTMLDivElement, ScrollbarProps>(
  ({ children, className, ...other }, ref) => {
    return (
      <div ref={ref} className={cn('overflow-auto', className)} {...other}>
        {children}
      </div>
    );
  }
);

Scrollbar.displayName = 'Scrollbar';

export default memo(Scrollbar);
